export const OcrKeys = {
    'member_id': ['member id', 'ID', 'identity', 'identification', 'no.', 'num', 'number', 'policy #', 'identification #'],
    'member_name': ['member name', 'name', 'first name', 'last name', 'full name', 'member', 'person'],
    'expiry_date': ['expiry date', 'expire', 'exp', 'valid till', 'valid'],
    'card_number': ['dl', 'number', 'id', 'no.', 'num', '#', 'dln', 'lic'],
    'card_type': ['license', 'driver', 'state', `driver's`],
    'card_issuer': ['state', 'government', 'federal']
}